import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SchoolMapItem } from '../../definitions/school-map-item';
import { MapItemComponent } from '@ui/shared/util-map';

import { DetailViewModule } from '@ui/shared/ui-detail-view';
import { SchoolMapItemMeasureDetailsComponent } from '../school-map-item-measure-details/school-map-item-measure-details.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-school-map-item-details',
    templateUrl: './school-map-item-details.component.html',
    styleUrls: ['./school-map-item-details.component.scss'],
    imports: [
        DetailViewModule,
        SchoolMapItemMeasureDetailsComponent,
    ],
})
export class SchoolMapDetailsComponent implements MapItemComponent<SchoolMapItem> {
    public mapItem = input<SchoolMapItem | undefined>();
}
